import { useLocation } from "react-router-dom";

/**
 * `?print=1` strips the site chrome and swaps in the light print palette.
 *
 * `build-docs-pdf.mjs` appends it so Puppeteer captures the article body only.
 * It is a query param rather than a media query because the PDF build needs the
 * chrome gone from the DOM (a `display: none` navbar still contributes to
 * Puppeteer's layout pass) and because it makes the print view inspectable in a
 * normal browser tab.
 */
export const useDocsPrintMode = (): boolean => {
    const { search } = useLocation();
    return new URLSearchParams(search).get("print") === "1";
};

export default useDocsPrintMode;
